var React = require('react');

function DotCircle (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n\t\t.dot-circle-s0 { fill: none;stroke: #56bbb1;stroke-width: 3;stroke-dasharray: 3 } \n\t\t.dot-circle-s1 { fill: none;stroke: #d1c8ba;stroke-width: 2 } \n\t"),React.createElement("circle",{"id":"Layer","className":"dot-circle-s0","cx":"243.5","cy":"243.5","r":"210","key":1}),React.createElement("circle",{"id":"Layer","className":"dot-circle-s1","cx":"243.5","cy":"243.5","r":"242.5","key":2})]);
}

DotCircle.defaultProps = {"version":"1.2","viewBox":"0 0 487 487","width":"487","height":"487"};

module.exports = DotCircle;

DotCircle.default = DotCircle;
